import { useRef, useState, useEffect } from 'react'
import type { ComponentPropsWithoutRef, ReactEventHandler } from 'react'

import styled from 'styled-components'

export type ImageProps = ComponentPropsWithoutRef<'img'> & {
  errorSrc?: string
  objectFit?: 'contain' | 'cover' | 'fill' | 'scale-down' | 'none'
  objectPosition?: 'right' | 'left' | 'center' | 'bottom' | 'top'
}

const StyledImage = styled.img<{ $objectFit; $objectPosition }>`
  object-fit: ${(props) => props.$objectFit};
  object-position: ${(props) => props.$objectPosition};
`

const Image = ({
  loading = 'lazy',
  objectFit = 'contain',
  objectPosition = 'center',
  ...rest
}: ImageProps) => {
  const withError = useRef<boolean>(false)
  const [currentSource, setCurrentSource] = useState<string | undefined>(rest.src)

  const handleError: ReactEventHandler<HTMLImageElement> = (event) => {
    if (rest.errorSrc && !withError.current) {
      setCurrentSource(rest.errorSrc)
      withError.current = true
    }

    rest.onError?.(event)
  }

  useEffect(() => {
    setCurrentSource(rest.src)
  }, [rest.src])

  return (
    <StyledImage
      {...rest}
      loading={loading}
      src={currentSource}
      onError={handleError}
      $objectFit={objectFit}
      $objectPosition={objectPosition}
    />
  )
}

export default Image
